module.exports = __webpack_public_path__ + "img/email-icon.554b8eb1.svg";